export default __webpack_public_path__ + "static/media/nen_3140_logo.511753ce.png";